import { Preferences } from '@capacitor/preferences';
import { isPlatformWeb } from './platform';

/**
 * Cross-platform storage utility that works on web and mobile platforms
 */
export class Storage {
  /**
   * Set a value in storage
   * @param key Storage key
   * @param value Value to store
   * @returns Promise that resolves when the operation completes
   */
  static async set(key: string, value: string): Promise<void> {
    if (isPlatformWeb()) {
      // Use sessionStorage on web
      sessionStorage.setItem(key, value);
      return Promise.resolve();
    } else {
      // Use Capacitor Preferences on mobile
      return Preferences.set({
        key,
        value
      });
    }
  }

  /**
   * Get a value from storage
   * @param key Storage key
   * @returns Promise that resolves with the value or null if not found
   */
  static async get(key: string): Promise<string | null> {
    if (isPlatformWeb()) {
      // Use sessionStorage on web
      return Promise.resolve(sessionStorage.getItem(key));
    } else {
      // Use Capacitor Preferences on mobile
      try {
        const { value } = await Preferences.get({ key });
        return value;
      } catch (error) {
        console.error(`Error getting value for key ${key}:`, error);
        return null;
      }
    }
  }

  /**
   * Remove a value from storage
   * @param key Storage key
   * @returns Promise that resolves when the operation completes
   */
  static async remove(key: string): Promise<void> {
    if (isPlatformWeb()) {
      // Use sessionStorage on web
      sessionStorage.removeItem(key);
      return Promise.resolve();
    } else {
      // Use Capacitor Preferences on mobile
      return Preferences.remove({ key });
    }
  }
} 